import React, {useRef} from "react"

export default function AutoPlaySilentVideo(props) {
    const videoRef = useRef(undefined);
    const {controls = true} = props;
    // useEffect(() => {
    //     videoRef.current.defaultMuted = true;
    // })


    const rewind = (seconds) => {
        if (videoRef.current) {
            videoRef.current.currentTime = Math.max(0, videoRef.current.currentTime - seconds);
        }
    };

    const forward = (seconds) => {
        if (videoRef.current) {
            videoRef.current.currentTime = Math.min(videoRef.current.duration, videoRef.current.currentTime + seconds);
        }
    };

    return (
      <>
        <video
            className={"w-100"}
            ref={videoRef}
            loop
            autoPlay={false}
            muted={false}
            playsInline
            controls={controls}
            height={400}
            >
            <source src={`${props.video}#t=0.001`} type="video/mp4"/>
        </video>
      
      <div>
        <span onClick={() => rewind(10)} style={{visibility:'hidden'}}>Previous</span>
        <span onClick={() => forward(10)} style={{visibility:'hidden'}}>Next</span>
      </div>
      </>

    );
}